const indexItems = [
  { id: 1, name: '古装剧', icon: 'ri-ancient-gate-line', count: '3200+ 部', color: 'bg-accent-100 text-accent-700' },
  { id: 2, name: '都市剧', icon: 'ri-building-line', count: '2800+ 部', color: 'bg-primary-100 text-primary-700' },
  { id: 3, name: '悬疑剧', icon: 'ri-search-eye-line', count: '1900+ 部', color: 'bg-secondary-100 text-secondary-700' },
  { id: 4, name: '爱情剧', icon: 'ri-heart-line', count: '3500+ 部', color: 'bg-accent-100 text-accent-700' },
  { id: 5, name: '年代剧', icon: 'ri-history-line', count: '1200+ 部', color: 'bg-secondary-100 text-secondary-700' },
  { id: 6, name: '喜剧', icon: 'ri-emotion-happy-line', count: '2100+ 部', color: 'bg-primary-100 text-primary-700' },
  { id: 7, name: '军旅剧', icon: 'ri-shield-star-line', count: '800+ 部', color: 'bg-secondary-100 text-secondary-700' },
  { id: 8, name: '奇幻剧', icon: 'ri-magic-line', count: '1500+ 部', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            剧集索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            按类型快速浏览，找到你感兴趣的全部电视剧
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-3 p-4 rounded-lg cursor-pointer transition-all duration-300 bg-background-50 border border-background-200 hover:border-primary-300 hover:ring-2 hover:ring-primary-100/50"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <div className="font-heading text-sm md:text-base text-foreground-900">{item.name}</div>
                <div className="text-xs text-foreground-400">{item.count}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}